import { useQuery } from '@tanstack/react-query';
import { factoryGetEligibleCandidatesKey } from '../factories/queries';
import { PermanentJobsService } from '../services';
import type { IGetEligibleCandidatesPayload } from '../types';

interface IUseGetEligibleCandidatesOptions {
  enabled?: boolean;
}

export const useGetEligibleCandidates = (
  payload: IGetEligibleCandidatesPayload,
  options?: IUseGetEligibleCandidatesOptions,
) => {
  const { data, error, isFetching, isLoading, isError } = useQuery({
    queryKey: factoryGetEligibleCandidatesKey(payload),
    queryFn: () => PermanentJobsService.getEligibleCandidates(payload),
    enabled: options?.enabled ?? true,
    refetchOnWindowFocus: false,
    staleTime: 0,
  });

  return {
    data: data?.data || [],
    error,
    isError,
    isInitialLoading: isLoading,
    isLoading: isLoading || isFetching,
  };
};
